import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { ERROR_CODES } from "../../../../lib/errors";
import type { ErrorCode } from "../../../../lib/errors";
import { iconForErrorCode } from "./errorCodeCopy";

export interface ErrorCopy {
  icon: ReactElement;
  title: string;
  description: string;
}

/** Resolves an ErrorCode to its display copy, sourced from en.json's "errors" namespace
 *  (icons are not translatable content, so those come from errorCodeCopy.tsx instead).
 *  Codes with no dedicated entry fall back to errors.default. */
export function useErrorState(code: ErrorCode): ErrorCopy {
  const { t } = useTranslation();
  const icon = iconForErrorCode(code);

  switch (code) {
    case ERROR_CODES.LLM.PROVIDER_UNAVAILABLE:
      return {
        icon,
        title: t("errors.llmProviderUnavailable.title"),
        description: t("errors.llmProviderUnavailable.description"),
      };
    case ERROR_CODES.LLM.RATE_LIMITED:
      return {
        icon,
        title: t("errors.llmRateLimited.title"),
        description: t("errors.llmRateLimited.description"),
      };
    case ERROR_CODES.LLM.AUTH_ERROR:
      return {
        icon,
        title: t("errors.llmAuthError.title"),
        description: t("errors.llmAuthError.description"),
      };
    case ERROR_CODES.RATE_LIMIT.EXCEEDED:
      return {
        icon,
        title: t("errors.rateLimitExceeded.title"),
        description: t("errors.rateLimitExceeded.description"),
      };
    case ERROR_CODES.DOCUMENT.FETCH_FAILED:
      return {
        icon,
        title: t("errors.documentFetchFailed.title"),
        description: t("errors.documentFetchFailed.description"),
      };
    default:
      return {
        icon,
        title: t("errors.default.title"),
        description: t("errors.default.description"),
      };
  }
}
